module.exports = __webpack_public_path__ + "img/cdkf2.9e1cef2b.webp";